<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="accessories"
      :page.sync="pagination.page"
      :items-per-page.sync="paginationAccessoriesAndOthers.rowsPerPage"
      :items-per-page-text="$t('tables.RowsPerPage')"
      :items-per-page-items="rowsPerPageItems"
      :header-props="{ sortIcon: 'mdi-menu-down' }"
      :footer-props="{ prevIcon: 'mdi-menu-left', nextIcon: 'mdi-menu-right','items-per-page-options': rowsPerPageItems }"
      @pagination="setRowsOnLocalStorage(dataTableAccessoriesAndOthersId,paginationAccessoriesAndOthers.rowsPerPage)"
      class="mt-2"
    >
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.sm_reference }}</td>
          <td>{{ props.item.sm_description }}</td>
          <td>
            {{
              props.item.sm_quantity
                ? props.item.sm_quantity
                : props.item.quantity
            }}
          </td>

          <td>
            <app-datatable-action-buttons
              :user-can-edit="disabled ? !disabled : canChangeAccessory"
              @edit="$emit('edit-item', props.index)"
              :user-can-delete="disabled ? !disabled : canChangeAccessory"
              @delete="askConfirmationToDeleteItem(props.index)"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
    <app-dialog-box
      :open="deleteDialog"
      :title="titleToDelete"
      :content="$t('DeleteConfirmation') + '?'"
      :main-action-label="$t('No')"
      @mainAction="cancelDelete"
      :secondary-action-label="$t('Yes')"
      @secondaryAction="confirmDelete()"
    />
  </div>
</template>

<script>
import AppDatatableActionButtons from "@/components/_Molecules/AppDatatableActionButtons";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
export default {
  name: "AccessoriesAndOthersTable",
  components: { AppDialogBox, AppDatatableActionButtons },
  mixins: [managementDatatableMixin],
  props: {
    accessories: {
      type: Array,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    canChangeAccessory: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      pagination: {
        sortBy: "title"
      },
      dataTableAccessoriesAndOthersId: "dataTableAccessoriesAndOthersId" ,
      paginationAccessoriesAndOthers: {
        rowsPerPage: this.getRowsFromLocalStorage("dataTableAccessoriesAndOthersId")
      },
      deleteDialog: false,
      itemToDelete: {},
      index: 0,
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$i18n.tc("Reference", 1),
          value: "sm_reference",
          width: "25%"
        },
        {
          text: this.$i18n.tc("Description", 1),
          value: "sm_description",
          width: "50%"
        },
        {
          text: this.$i18n.t("Quantity"),
          value: "quantity",
          width: "15%"
        },
        {
          text: "",
          value: "action",
          width: "15%"
        }
      ];
    },

    titleToDelete() {
      let title = this.$i18n.t("Delete");
      if (this.itemToDelete && this.itemToDelete.sm_reference) {
        title += " " + this.itemToDelete.sm_reference;
      }
      return title;
    }
  },

  methods: {
    askConfirmationToDeleteItem(value) {
      this.deleteDialog = true;
      this.index = value;
    },

    confirmDelete() {
      this.$emit("delete-item", this.index);
      this.cancelDelete();
    },

    cancelDelete() {
      this.deleteDialog = false;
      this.itemToDelete = {};
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/AccessoriesAndOthers/AccessoriesAndOthersTable.vue